import React from "react";
import {useTable, useSortBy} from "react-table";
import {useSelector} from "react-redux";
import ReactPaginate from "react-paginate";
import {DefaultArrow, DownArrow, UpArrow} from "../../../Resident/sortArrows";

const FacilitiesTab = () => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      affiliateMemberId: state.affiliateMember.id,
    }
  });

  const [facilities, setFacilities] = React.useState([]);
  const [nameSort, setNameSort] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);

  const fetchFacilities = () => {
    const {organizationName, affiliateMemberId} = state;
    $.ajax({
      url: `/organizations/${organizationName}/facilities.json?${$.param(createRansackQuery())}`,
      success: (response) => {
        setFacilities(response.facilities);
        setTotalPages(response.total_pages);
        setCurrentPage(response.current_page);
      }
    })
  }

  const createRansackQuery = () => {
    const {affiliateMemberId} = state;
    return {
      q: {
        affiliate_member_id_eq: affiliateMemberId,
        s: `name ${nameSort}`,
      },
      page: currentPage
    }
  }

  React.useEffect(() => {
    fetchFacilities();
  }, [nameSort, currentPage]);

  const columns = React.useMemo(() => [
    {
      Header: "Facility Name",
      id: "name",
      accessor: (row) => row.name,
      Cell: ({cell: {row: {original}}}) => (
        <a href={`/organizations/${state.organizationName}/facilities/${original.id}`} target="_blank">{original.name}</a>
      )
    },
    {
      Header: "Join Date",
      id: "join_date",
      accessor: (row) => row.display_join_date,
      disableSortBy: true
    },
    {
      Header: "Membership Status",
      id: "membership_status",
      accessor: (row) => row.display_membership_status,
      disableSortBy: true
    },
    {
      Header: "Application Status",
      id: "application_status",
      accessor: (row) => row.display_application_status,
      disableSortBy: true
    },
    {
      Header: "Next Inspection Date",
      id: "next_inspection_date",
      accessor: (row) => row.display_next_inspection_date,
      disableSortBy: true
    },
    {
      Header: "Next Renewal Date",
      id: "next_renewal_date",
      accessor: (row) => row.display_next_renewal_date,
      disableSortBy: true
    },
    {
      Header: "Census",
      id: "census",
      accessor: (row) => row.display_census,
      disableSortBy: true
    },
    {
      Header: "Gender",
      id: "gender",
      accessor: (row) => row.display_gender,
      disableSortBy: true
    },
    {
      Header: "Demographics",
      id: "demographics",
      accessor: (row) => row.display_demographics,
      disableSortBy: true
    },
  ], [facilities])

  const sortByValues = () => {
    if(nameSort === null) {
      return [];
    }
    return [
      {
        id: "name",
        desc: nameSort === "desc"
      }
    ]
  }

  const {getTableProps, headerGroups, rows, prepareRow, state: { sortBy }} = useTable(
    {
      columns,
      data: facilities,
      initialState: {

        sortBy: sortByValues()
      },
      manualSorting: true
    },
    useSortBy
  );


  React.useEffect(() => {
    if (sortBy.length > 0) {
      const sort = sortBy[0];
      setNameSort(sort.desc === true ? "desc" : "asc");
    }
  }, [sortBy]);

  return (
    <>
      <table {...getTableProps()} className="table table-responsive">
        <thead>
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                {column.render('Header')}
                {
                  !column.disableSortBy && (
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? <DownArrow /> : <UpArrow />) : <DefaultArrow />}
                    </span>
                  )
                }
              </th>
            ))}
            <th />
          </tr>
        ))}
        </thead>
        <tbody>
        {rows.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => {
                  return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
        )}
        </tbody>
      </table>
      {
        totalPages > 1 && <ReactPaginate
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          pageCount={totalPages}
          onPageChange={(page) =>
            setCurrentPage(page.selected + 1)
          }
        />
      }
    </>
  )
}

export default FacilitiesTab